import type { CategoryCode } from 'types/Category';

export const PEACE_OF_MIND_EXCLUDED_CATEGORY_CODES = new Set<CategoryCode>([
	'REC', // Venues
	'BWP', // Bridal salons
	'DNC', // Dance lessons
	'BAR', // Bar services
	'DEC', // Decor
	'SPV', // Rehearsal dinners, bridal showers + parties
	'TRV', // Travel specialists
	'JWL', // Jewelers
]);
